var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.223,
    height: 64.254,
    viewBox: "0 0 70.223 64.254"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_3317",
    "data-name": "\\u30D1\\u30B9 3317",
    d: "M138.249,262.851a4.147,4.147,0,0,0-5.858.287l-38.173,42.1L76.213,290.476a4.176,4.176,0,0,0-6.066,5.629L88.86,322.751a7.854,7.854,0,0,0,1.945,1.924,7.709,7.709,0,0,0,10.719-1.992l.306-.445,37.052-53.967A4.148,4.148,0,0,0,138.249,262.851Z",
    transform: "translate(-69.388 -261.775)",
    fill: "#fff"
  })));
};
export default SvgChecked;